
const user  = (state = { userCredentials: { token: '', authContext: {} }, auth: null, data: {}, initData: false, sidebar: false, station: null, stationCheck: null }, action) => {
    switch(action.type){
        case 'USER_LOGIN':
            return new Object({
                userCredentials: action.user,
                auth: action.auth,
                data: state.data,
                initData: false,
                sidebar: state.sidebar,
                station: state.station,
                stationCheck: state.stationCheck
            });
        case 'USER_LOGOUT':
            return new Object({
                userCredentials: { token: '', authContext: {} },
                auth: action.auth,
                data: {},
                initData: false,
                sidebar: state.sidebar,
                stationCheck: state.stationCheck
            });
        case 'GET_INIT_DATA':
            return new Object({
                userCredentials: state.userCredentials,
                auth: state.auth,
                data: action.data,
                initData: true,
                sidebar: state.sidebar,
                station: state.station,
                stationCheck: state.stationCheck
            });
        case 'TOGGLE_SIDEBAR':
            return new Object({
                ...state,
                sidebar: !state.sidebar
            });
        case 'CLOSE_SIDEBAR':
            return new Object({
                ...state,
                sidebar: false
            });
        case 'SET_STATION':
            return new Object({
                ...state,
                station: action.station,
                stationCheck: action.stationCheck
            });
    }
    return state;
};

export default user;
